import { Context, createContext } from 'react';
import { TNotificationContext } from '../../types';
import initialState from '../constants';

const NotificationContext: Context<TNotificationContext> =
  createContext(initialState);

export default NotificationContext;
